import React, { useState, useEffect } from 'react'
import { Container, Button } from 'reactstrap'
import { useSelector } from 'react-redux'
import { stripeCheckoutCreateSession } from '../../api/stripe'
import config from '../../config/stripe'

const monthlyAmount = 40
const yearlyAmount = 32
const trialDays = 21

const features = [
  'Unlimited AI Generated analysis and reports',
  'Unlimited number of feedback',
  'Form customization',
  'Import existing data',
  'Premium support',
  'Premium technical support during integration'
]

let domain = `https://${window.location.hostname}`

if (window.location.hostname === 'localhost') {
  domain = 'http://localhost:3000'
}

export default function Pricing ({ successUrl, cancelUrl }) {
  const [isYearly, setIsYearly] = useState(true)
  const [planSelected, setPlanSelected] = useState(config.prices.yearly)
  const [stripeSession, setStripeSession] = useState(null)
  const account = useSelector(state => state.accountReducers.account)
  const user = useSelector(state => state.userReducers.user)

  const price = isYearly ? yearlyAmount : monthlyAmount
  const priceNote = isYearly ? `$${monthlyAmount}/mo when you pay monthly` : ''

  useEffect(() => {
    stripeCheckoutCreateSession(
      account?.id || 'anonymous',
      planSelected,
      trialDays,
      `${domain}/${successUrl}`,
      `${domain}/${cancelUrl}`,
      user?.id
    )
      .then(session => {
        console.log(session)
        setStripeSession(session)
        // accountUpdate(account.id, { stripe_session_id: session.sessionObject.id })
      })
  }, [planSelected, successUrl, cancelUrl])

  const startStripe = async () => {
    if (stripeSession.session_url) {
      window.location.href = stripeSession.session_url
    }
  }

  return (
    <Container className="d-flex flex-column align-items-center justify-content-center">
      <h1 style={{ fontSize: 24, color: '#fff', marginBottom: 24 }}>Pricing</h1>
        <div style={{ display: 'flex', gap: 32, marginBottom: 32, alignItems: 'center', justifyContent: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: isYearly ? '#faffb8' : '#fff', fontWeight: isYearly ? 600 : 400 }}>
            <input type="radio" checked={isYearly} onChange={() => {
              setIsYearly(true)
              setPlanSelected(config.prices.yearly)
            }} style={{ accentColor: '#faffb8', marginRight: 8 }} />
            <span style={{ fontSize: 14, fontWeight: 400, color: '#fff' }}>
              Pay yearly (20% discount)
            </span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: !isYearly ? '#faffb8' : '#fff', fontWeight: !isYearly ? 600 : 400 }}>
            <input type="radio" checked={!isYearly} onChange={() => {
              setIsYearly(false)
              setPlanSelected(config.prices.monthly)
            }} style={{ accentColor: '#faffb8', marginRight: 8 }} />
            <span style={{ fontSize: 14, fontWeight: 400, color: '#fff' }}>
              Pay monthly
            </span>
          </label>
        </div>
        <div style={{ background: '#28272d', borderRadius: 32, padding: '40px 32px', minWidth: 340, maxWidth: 400, marginBottom: 32, boxShadow: '0 4px 32px #0002', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ fontSize: 44, fontWeight: 700, color: '#fff', marginBottom: 8 }}>
            ${price} / mo
          </div>
          {isYearly && <div style={{ color: '#7c7e8c', fontSize: 18, marginBottom: 24 }}>{priceNote}</div>}
          <div style={{ width: '100%', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 16 }}>Plan includes:</div>
            <ul style={{ color: '#fff', fontSize: 14, marginBottom: 0, marginLeft: 16 }}>
              {features.map((feature, idx) => (
                <li key={idx} style={{ marginBottom: 4, paddingLeft: 8 }}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginBottom: 32, fontSize: 14 }}>
          Start your <span style={{ color: '#faffb8' }}>free 3 week trial</span> today. {/* No credit card required. */}
        </div>
        <Button
          style={{
            background: '#faffb8',
            color: '#232228',
            fontWeight: 700,
            fontSize: 16,
            border: 'none',
            borderRadius: 24,
            padding: '13px 24px',
            marginBottom: 40
          }}
          disabled={!stripeSession}
          onClick={() => startStripe()}
        >
          Start free trial
        </Button>
    </Container>
  )
}
